import checkout from "./form";

const {
  formField: { organizeName, taxId, checkbox1, checkbox2, checkbox3, checkbox4, checkbox5 },
} = checkout;

const initialValues = {
  [organizeName.name]: "",
  [taxId.name]: "",
  [checkbox1.name]: "",
  [checkbox2.name]: "",
  [checkbox3.name]: "",
  [checkbox4.name]: "",
  [checkbox5.name]: "",
};

export default initialValues;
